// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"u9-z"};